var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page403/Page403.styled.ts";
import styled from 'styled-components';
import { KeyIcon } from './KeyIcon';
import { PathIcon } from './PathIcon';
export const Page403Composition = styled.div`
  position: relative;
  margin-bottom: 50px;
  width: 392px;
  margin-top: 76px;
`;
export const PathPositioned = styled(PathIcon)`
  position: absolute;
  left: 55px;
  bottom: 51px;
`;
export const KeyPositioned = styled(KeyIcon)`
  position: absolute;
  right: 0;
  bottom: 76px;
`;
export const Page403List = styled.ul`
  margin: 0;
  padding: 0 24px;
  color: #4c5ecf;
  & li {
    cursor: pointer;
    width: max-content;
  }
  & ::marker {
    color: #353b60;
  }
`;